module.exports = {"441802006":"凤城街道","441802007":"东城街道","441802008":"洲心街道","441802009":"横荷街道","441802103":"源潭镇","441802105":"龙塘镇","441802106":"石角镇","441802107":"飞来峡镇","441802400":"清远市高新技术产业开发区","441802450":"清远市国营银盏林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441802.json
// module id = 2046
// module chunks = 0